import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './GenericCardComponent.css';

const truncateWords = (text, numWords) => {
  if (!text) return '';
  const words = text.split(' ');
  if (words.length <= numWords) return text;
  return words.slice(0, numWords).join(' ') + '...';
};

/**
 * GenericCardComponent
 * @param {Array} cards - Array of card objects with icon, title, summary, description
 * @param {string} className - Optional className for the card container
 */
const GenericCardComponent = ({ cards, className = '' }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', description: '' });

  const handleOpenModal = (card) => {
    setModalContent({ title: card.title, description: card.description });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className={`generic-card-container ${className}`}>
        {cards.map((card, idx) => {
          const showTruncatedSummary = card.summary && card.summary === card.description;
          return (
            <div className="generic-card" key={card.title + idx}>
              {card.icon != null && (
                <div className="generic-card-icon">
                  {typeof card.icon === 'string' ? (
                    <img src={card.icon} alt="icon" />
                  ) : (
                    card.icon
                  )}
                </div>
              )}
              <div className="generic-card-title">{card.title}</div>
              {card.summary && (
                <div className="generic-card-summary">
                  {showTruncatedSummary ? truncateWords(card.summary, 20) : card.summary}
                </div>
              )}
              <img
                src="/images/masterprimarybutton.svg"
                alt="action"
                className="uco-card-action"
                onClick={() => handleOpenModal(card)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          );
        })}
      </div>
      {modalOpen && (
        <div className="generic-card-modal-overlay" onClick={handleCloseModal}>
          <div className="generic-card-modal" onClick={e => e.stopPropagation()}>
            <button className="generic-card-modal-close" onClick={handleCloseModal}>&times;</button>
            <h2 className="generic-card-modal-title">{modalContent.title}</h2>
            <div className="generic-card-modal-description">{modalContent.description}</div>
          </div>
        </div>
      )}
    </>
  );
};

GenericCardComponent.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      title: PropTypes.string.isRequired,
      summary: PropTypes.string,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default GenericCardComponent; 